// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    baseUrl: 'https://testadmin.recuvery.com/api/admin/',
    exportUrl: 'https://testadmin.recuvery.com/export/admin/',
    // exportUrl: 'http://localhost:3000/admin/',
    // baseUrl: 'http://localhost:3000/admin/',
    app_version: 130,
    app_type: 1,
    device_type: 0,
    device_token: 'Website',
    env: 'TEST',
    url: 'https://testadmin.recuvery.com/',
    
    business_stripe_url: 'https://dashboard.stripe.com/test/connect/accounts/',
    socketBaseUrl: 'https://testadmin.recuvery.com',
    socketPath:'/api/socket.io',
    id_encoding_key: 58437291,
    id_encoding_length: 15,
};
